// This icon file is generated automatically.
var PRotateRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.5 2.92l.61-.03v1c0 .1.12.15.2.09l2-1.58a.12.12 0 000-.2l-2-1.57a.12.12 0 00-.2.1v1A6.26 6.26 0 00.93 8.86H2.1a5.1 5.1 0 014.4-5.93zm6.25 2.61H4.5a.5.5 0 00-.5.5v6.47c0 .28.22.5.5.5h8.25a.5.5 0 00.5-.5V6.03a.5.5 0 00-.5-.5zm-.69 6.28H5.2v-5.1h6.87v5.1z", "fill-rule": "nonzero" } }] }, "name": "p-rotate-right", "theme": "outlined" };
export default PRotateRightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRotateRightOutlined.js
// module id = 3606
// module chunks = 0